/* tslint:disable */

declare var Object: any;
export interface EncuestasInterface {
  "id": number;
  "titulo": string;
  "descripcion"?: string;
  "fechaInicio"?: Date;
  "fechaFin"?: Date;
  "estado"?: string;
}

export class Encuestas implements EncuestasInterface {
  "id": number;
  "titulo": string;
  "descripcion": string;
  "fechaInicio": Date;
  "fechaFin": Date;
  "estado": string;
  constructor(data?: EncuestasInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Encuestas`.
   */
  public static getModelName() {
    return "Encuestas";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Encuestas for dynamic purposes.
  **/
  public static factory(data: EncuestasInterface): Encuestas{
    return new Encuestas(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Encuestas',
      plural: 'Encuestas',
      path: 'Encuestas',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "titulo": {
          name: 'titulo',
          type: 'string'
        },
        "descripcion": {
          name: 'descripcion',
          type: 'string'
        },
        "fechaInicio": {
          name: 'fechaInicio',
          type: 'Date'
        },
        "fechaFin": {
          name: 'fechaFin',
          type: 'Date'
        },
        "estado": {
          name: 'estado',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/Encuestas.ts